import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export interface SimilarSizeComponentProps {
  children: React.ReactNode;
}

const SimilarSizeComponent = React.forwardRef<HTMLDivElement, SimilarSizeComponentProps>(
  ({ children }, ref): JSX.Element => {
    return <Wrapper ref={ref}>{children}</Wrapper>;
  },
);

export interface SimilarSizeProps
  extends React.ForwardRefExoticComponent<SimilarSizeComponentProps & React.RefAttributes<HTMLDivElement>>,
    SimilarSizeCompoundProps {}

interface SimilarSizeCompoundProps {
  Header: typeof Header;
  TooltipTrigger: typeof TooltipTrigger;
  Title: typeof Title;
  Subtitle: typeof Subtitle;
  Pink: typeof Pink;
  Sticky: typeof Sticky;
}

const Wrapper = styled.div`
  padding: 24px 0 0;
  position: relative;
`;

const Header = styled.div`
  padding: 0 24px 8px;
  letter-spacing: -0.3px;
  position: relative;
`;

const TooltipTrigger = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 3px;
  right: 24px;
  z-index: 1;
`;

const Title = styled.p`
  margin-bottom: 2px;
`;

const Subtitle = styled.p`
  max-width: calc(100% - 40px);
  display: flex;
`;

const Pink = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${vars.v3Color.pink400};
  display: inline-block;
  max-width: fit-content;
  flex: 0 1 content;
`;

const StickyRightStyle = css`
  flex: 1 0 content;
  padding-left: 3px;
`;

const StickyLeftStyle = css`
  padding-right: 3px;
`;

const Sticky = styled.span<{ lang: string }>`
  white-space: nowrap;
  ${({ lang }) => (lang === 'en' ? StickyLeftStyle : StickyRightStyle)};
`;

export const SimilarSize = {
  ...SimilarSizeComponent,
  Header,
  TooltipTrigger,
  Title,
  Subtitle,
  Pink,
  Sticky,
} as SimilarSizeProps;
